import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Button, Icon, Modal, Grid, Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

const {
  changeWtsParamSelected,
  createWtsParam,
  updateWtsParam,
} = Actions;

const WtsParamsModal = ({mode, paramToEdit}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const paramSelected = useSelector((state) => state.wtsParams.paramSelected);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);

  const onChangeValues = (key, value) => {
    const changedParamSelected = {...paramSelected, [key]: value};
    dispatch(changeWtsParamSelected(changedParamSelected));
  };

  const showParamModal = (e, value) => {
    e.preventDefault();
    setShowModal(value);
    if (mode === 'edit') {
      dispatch(changeWtsParamSelected(paramToEdit));
    } else {
      dispatch(changeWtsParamSelected({
        'codigo_llave': '',
        'descripcion': '',
        'valor_fecha': '',
        'valor_numerico': '',
        'valor_texto': '',
      }));
    }
  };

  const saveParamModal = (e) => {
    e.preventDefault();
    if (mode === 'new') {
      dispatch(createWtsParam({...paramSelected, 'area': areaSelected?.id}, areaSelected?.id));
    } else {
      dispatch(updateWtsParam(paramSelected?.param_id, {...paramSelected, 'area': areaSelected?.id}, areaSelected?.id));
    }
    showParamModal(e, false);
  };

  return (
    <Modal size='tiny' closeOnEscape={false} closeOnDimmerClick={false}
      open={showModal}
      trigger={
        mode === 'new' ?
          <Button compact content="Añadir"
            icon={<Icon name='add-circle' size='big' color='green' />}
            onClick={(e) => showParamModal(e, true)} /> :
          <Icon link name='pencil' size='big' onClick={(e) => showParamModal(e, true)} color='green' />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            {mode === 'new' ? 'Crear parámetro' : 'Editar parámetro'}
          </h2>
          <Icon className='download' name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showParamModal(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid stackable stretched>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Código Llave"
                value={paramSelected?.codigo_llave || ''}
                disabled={mode !== 'new'}
                onChange={(e, {value}) => onChangeValues('codigo_llave', value.toUpperCase())}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Descripción"
                value={paramSelected?.descripcion || ''}
                onChange={(e, {value}) => onChangeValues('descripcion', value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Valor Numérico"
                type="number"
                value={paramSelected?.valor_numerico || ''}
                onChange={(e, {value}) => onChangeValues('valor_numerico', value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Valor Texto"
                value={paramSelected?.valor_texto || ''}
                onChange={(e, {value}) => onChangeValues('valor_texto', value)}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Input fluid
                label="Valor Fecha"
                type="date"
                value={paramSelected?.valor_fecha || ''}
                onChange={(e, {value}) => onChangeValues('valor_fecha', value)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          compact
          icon='save'
          onClick={(e) => saveParamModal(e)}
        >
          Guardar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default WtsParamsModal;
